import HeroWithTagAndAnimation from './hero-with-tag-and-animation';

export default HeroWithTagAndAnimation;
